module.exports = __webpack_public_path__ + "bcf9d742f775c18fcddbe975f601aedc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-20.png
// module id = 2080
// module chunks = 0